export default __webpack_public_path__ + "static/the-empire-896fb9092fcb2c8218552d75e402f066.webp";